import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { SearchService } from '../services/search.service';

@Pipe({ name: 'searchServiceGetNamePipe' })
export class DisplayNamePipe implements PipeTransform {
  constructor(private service: SearchService) {}
  transform(userId: string | null): Observable<string> {
    if (!userId) {
      return of('');
    }

    return this.service.getResults(userId).pipe(
      map((res) => {
        const result = res.find((userInfo) => userId === userInfo.id);
        return result?.displayName ?? userId;
      })
    );
  }
}
